import React from 'react'
import { Badge, Col, ListGroupItem } from 'react-bootstrap'
import { User, UserRole } from '../models/User'
import Avatar from './Avatar';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useNavigate } from 'react-router-dom';

type Props = {
  user: User;
  actions?: React.ReactNode;
  trailing?: React.ReactNode;
}

export default function UserItem({ user, trailing, actions }: Props) {
  
  const navigate = useNavigate();

  const renderUserIcon = (role: UserRole) => {
    var icon: IconProp;
    switch (role) {
      case UserRole.ADMIN: icon = solid("user-cog"); break;
      case UserRole.DOCTOR: icon = solid("user-md"); break;
      case UserRole.RESEARCHER: icon = solid("user-nurse"); break;
      case UserRole.PATIENT: default: icon = solid("user"); break;
    }

    return <FontAwesomeIcon icon={icon} />
  }
  return (
    <ListGroupItem className="d-flex align-items-center">
      <div className="pe-3">
        <Avatar user={user} />
      </div>

      <Col>
        <h6 className="mb-0 highlight h6" onClick={() => navigate(`/users/${user.id}/details`)}>{user.firstname} {user.lastname} </h6>
        <Badge bg="light" className="border text-muted">
          {renderUserIcon(user.role)}
          <span className="ms-2">{user.role}</span>
        </Badge>
        {trailing}
      </Col>

      <Col>

      </Col>

      {actions && <div className="ps-3 text-end">{actions}</div>}
    </ListGroupItem>
  )
}